'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export   = require(32)
  , $includes = require(11)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require(5)('includes');